<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Content from '@/services/Content'
    import Swal from "sweetalert2";
    import modalUploadVideo from "../../../components/modals/news/modalUploadVideo.vue";


    export default {
        components: { Layout, PageHeader, modalUploadVideo},
        page: {
            title: "Shorts",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                title: "Youtube Shorts",
                items: [
                    {
                        text: "News",
                    },
                    {
                        text: "Shorts",
                        active: true,
                        href: "/news/shorts",
                    },
                ],
                showRefresh:true,
                showAlert: false,
                isBusy: false,
                isBusyButton: false,
                error: null,
                showModal:false,
                modalData:{},
                link_id:null,
                tableData: [],
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "published",
                sortDesc: true,
                fields: [
                    {
                        key: "title",
                        label: "Title",
                        sortable: true,
                    },
                    {
                        key: "videourl",
                        label: "Link",
                        sortable: false,
                    },
                    {
                        key: "image",
                        label: "Image",
                        sortable: false,
                    },
                    {
                        key: "published",
                        label: "Published Date",
                        sortable: true,
                    },
                    "action",
                ],
                    "refreshShortsBtn":false
            };
        },
        async created() {
            await this.getShorts()
            this.refreshShortsBtn = await this.checkObjectAccessCall('button.shorts.refresh');
        },
        methods: {
            openModalUploadShort(){
                this.$bvModal.show('upload_short');
            },
            async getShorts(){
                try {
                    this.toggleBusy();
                    const limit = 1000;
                    const response = await Content.getShorts(limit)
                    this.tableData = response.data.videos
                    this.totalRows = this.tableData.length
                    this.toggleBusy();
                } catch (error) {
                    this.toggleBusy();
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                }
            },

              removeShorts(id){
                Swal.fire({
                    title: "Remove shorts article?",
                    text: "This shorts article will be removed!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Remove!",
                }).then((result) => {
                    if (result.value) {
                        try {
                            Content.removeShorts(id)
                                .then((response) => {
                                    const res = response.data ? response.data : false;
                                    const error = response.data.error ? response.data.error : 'Failed';
                                    if(res){
                                        this.getShorts()
                                        Swal.fire("Remove Shorts", "Shorts article is successfully removed!", "success");
                                    }else{
                                        Swal.fire("Fail!", error, "warning");
                                    }
                                })
                        }catch(error){
                            this.error = error.response.data.error ? error.response.data.error : "";
                        }
                    }
                });
            },
          restoreShorts(id){
            Swal.fire({
              title: "Restore short article?",
              text: "This short article will be restored!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Restore!",
            }).then((result) => {
              if (result.value) {
                try {
                  Content.restoreShort(id)
                      .then((response) => {
                        console.log(response,'response')
                        const res = response.data ? response.data : false;
                        const error = response.data.error ? response.data.error : 'Failed';
                        if(res){
                          this.getShorts()
                          Swal.fire("Restore short", "Short article is successfully restored!", "success");
                        }else{
                          Swal.fire("Fail!", error, "warning");
                        }
                      })
                }catch(error){
                  this.error = error.response.data.error ? error.response.data.error : "";
                }
              }
            });
          },
                async refreshShorts() {
                  try {
                    this.isBusyButton = true;
                    const response = await Content.fireEvent({event_type: 'refresh_shorts'});
                    if(response.data.data == 'refreshed') {
                         this.showRefresh = false;
                         this.showAlert = true;
                           setTimeout(() => {
                               this.showAlert = false;
                               this.showRefresh = true;
                               this.getShorts();
                             }, 10000); // 10 seconds

                    }
                     this.isBusyButton = false;

                } catch (error) {
                    this.isBusyButton = false;
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                }
            },

            /**
             * Search the table data with search input
             */
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },

        },
        middleware: "authentication",
    };
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-0">
                            <div class="col-12">
                                 <!-- When the Refresh Shorts button is clicked, an event is triggered. Shorts may not be available immediately. Timeout set before refreshing the table -->
                                <div v-if="showAlert" class="alert alert-warning" role="alert">
                                  Refresh initiated! The pulled shorts will be available shortly.
                               </div>
                            </div>
                            <div v-if="showRefresh" class="row col-12 mb-2">
                                <div class="col-6 text-start">
                                    <a href="javascript:void(0);" @click="openModalUploadShort()"
                                        class="btn btn-success waves-effect waves-light text-end">
                                        <span>Upload Short</span>
                                    </a>
                                </div>
                                <div class="col-6 text-end">
                                    <a v-if="refreshShortsBtn" href="javascript:void(0);" :disabled=isBusyButton class="btn btn-success waves-effect waves-light text-end" @click="refreshShorts()">
                                        <span v-if="!isBusyButton"><i class="mdi mdi-refresh me-2"></i>Refresh Shorts</span>
                                        <span v-else>Loading...</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <h4 class="card-title">Total Shorts : {{totalRows}}</h4>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                        id="tickets-table_filter"
                                        class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    :busy="isBusy"
                                    :items="tableData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    show-empty
                                    empty-text="No Data Found"
                                    @filtered="onFiltered"
                            >

                                <template v-slot:cell(videourl)="data">
                                    <a :href="data.item.videourl" target="_blank">{{data.item.videourl}}</a>
                                </template>

                                <template v-slot:cell(image)="data">
                                    <div class="flex-shrink-0">
                                        <img class="img-fluid table-images" :src="data.item.image">
                                    </div>
                                </template>

                                <template v-slot:cell(action)="data">
                                    <ul class="list-inline mb-0">
                                        <li v-if="data.item.deleted === 0" class="list-inline-item">
                                            <a href="javascript:void(0);" class="px-2 text-danger"  title="Remove Shorts" @click="removeShorts(data.item.id)">
                                                <i class="uil uil-trash-alt font-size-18"></i>
                                            </a>
                                        </li>
                                      <li v-if="data.item.deleted === 1"  class="list-inline-item">
                                        <a href="javascript:void(0);" class="px-2 text-danger"  title="Restore Shorts" @click="restoreShorts(data.item.id)">
                                          <i class="fas fa-trash-restore-alt font-size-15"></i>
                                        </a>
                                      </li>
                                    </ul>
                                </template>

                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div
                                        class="dataTables_paginate paging_simple_numbers float-end"
                                >
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modalUploadVideo
            modal-id="upload_short"
            upload-mode="short"
            header-title="Upload Short"
            header-subtitle="Upload a new short to the feed"
            @onRefresh="getShorts()"
        ></modalUploadVideo>

    </Layout>
</template>